import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import StartUp from "./pages/startUp/StartUp";
import TemplateLoader from "./pages/templateLoader/TemplateLoader";
import Header from "./components/header/Header";
import "bootstrap/dist/css/bootstrap.min.css";
import FontSelector from "./pages/fontSelection/FontSelector";
import { useEffect, useState } from "react";
import ModalComponent from "./components/modal/Modal";
import ColorSelector from "./pages/colorSelection/ColorSelector";
import { AppContext } from "./components/provider/AppContext";
import AppContextDisplayer from "./components/provider/AppContextDisplayer";
import Footer from "./components/footer/Footer";
import styles from "./App.module.css";
import axios from "axios";
import NonDismissableModal from "./components/modal/NonDismissableModal";
import { create } from "zustand";
import Review from "./pages/checkoutReview/Review";
import ErrorModal from "./components/errorBoundary/ErrorBoundary";
import { getErrorMessage } from "./ErrorUtils";

export const plannerStore = create((set) => ({
  color: "",
  letters: [],
  sizeSelected: "",
  borderSelected: "",
  templateSelected: "",
  plannerType: "",
  fontStyle: "",
  showPlanner: false,
  isInStart: undefined,
  plannerColor: "",
  updateColor: (color) => set({ color }),
  updatePlannerColor: (plannerColor) => set({ plannerColor }),
  updateLetters: (letters) => set({ letters }),
  updateSizeSelected: (sizeSelected) => set({ sizeSelected }),
  updateBorder: (borderSelected) => set({ borderSelected }),
  updateTemplateSelected: (templateSelected) => set({ templateSelected }),
  updatePlannerType: (plannerType) => set({ plannerType }),
  updateFontStyle: (fontStyle) => set({ fontStyle }),
  setShowPlanner: (showPlanner) => set({ showPlanner }),
  setIsInStart: (isInStart) => set({ isInStart }),
}));

//QR CODE IF THE SITE IS NOT ON MOBILE
//TODO: Fix buttons and title showing and not shpwing PYW-03
//TODO: fix displayer not being properly sized when phone changes
//TODO: fix styling throughout
//TODO: SessionStorage instead of state since when you reload everything unsaves
//TODO: Colors
//TODO: Angela needs a site to basically do out of stock
//TODO: You can skip the calendar planner
//TODO: Flow size (price), Selecting templates
//TODO: Border selected then ask about calendar ((Dont forget about the description of the planner))
//TODO: Calendar none --> done
//pt2 press every 5 weeks or all together
//One page is every 5 weeks 12 months and all together 12 months
//TODO: Buttons at the bottom
//TDOD: Cricut
//TODO: 2 pages planners calendars can only fit 6 months every 5 weeks or all together.
//TODO: stay on task, lined and graph do not have calendar

function App() {
  useEffect(() => {
    const unsubscribe = plannerStore.subscribe((state) => {
      console.log(state);
    });

    return () => unsubscribe(); // cleanup on unmount
  }, []);

  const [showPlanner, setShowPlanner] = useState(false);
  const [error, setError] = useState("");
  const {
    isInStart,
    bindColor,
    fontStyle,
    letters,
    plannerType,
    color,
    templateSelected,
  } = plannerStore();
  const notInStart = window.location.href.split("/")[3] !== "";

  const onPlannerModalClose = async () => {
    try {
      const response = await axios.post(
        "https://createpaymentlink-jgex6zds4a-uc.a.run.app",
        {
          bindColor: color,
          fontStyle: fontStyle,
          calendar: plannerType,
          letters: Object.values(letters)?.join(""),
          cost: 25.0,
        }
      );
      if (response.data && response.data.paymentLinkUrl) {
        window.location.href = response.data.paymentLinkUrl;
      } else {
        console.error(
          "Error: Response data does not have paymentLinkUrl or data is empty"
        );
      }
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      console.log(errorMessage);
      setError(errorMessage);
    }
    setShowPlanner(false);
  };
  var isNotMobile =
    !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );

  return (
    <div className="container flex flex-col h-screen min-h-screen w-screen min-w-screen justify-evenly bg-main-bg">
      <div className={"flex-1"} style={{ display: isNotMobile ? "none" : "" }}>
        <ErrorModal
          show={error}
          onClose={() => setError("")}
          children={error ?? ""}
        />
        <NonDismissableModal show={isNotMobile} />
        <Router>
          {<Header setShowPlanner={setShowPlanner} />}

          <Routes>
            <Route path="/" element={<StartUp />} />
            <Route path="/colorSelection" element={<ColorSelector />} />
            <Route path="/template" element={<TemplateLoader />} />
            <Route path="/font" element={<FontSelector />} />
          </Routes>

          {isInStart || notInStart ? (
            <Footer setShowPlanner={setShowPlanner} />
          ) : null}

          <ModalComponent
            onExit={onPlannerModalClose}
            title={"Planner Selection"}
            show={showPlanner}
            setShowPlanner={setShowPlanner}
          >
            <Review onClose={onPlannerModalClose} />
            {/* <AppContextDisplayer /> */}
          </ModalComponent>
        </Router>
      </div>
      <footer className="bottom-0 bg-black-800 text-black text-center p-4x italic">
        © Plan Your Way Inc.
      </footer>
    </div>
  );
}

export default App;
